// Auto generated file, do not manually modify!
// com.hotpads.propertycondition.client.enums.PropertyConditionPhase

export enum PropertyConditionPhase {
  MOVE_IN = 'MOVE_IN',
  MOVE_OUT = 'MOVE_OUT',
}

export const PropertyConditionPhase_values = [PropertyConditionPhase.MOVE_IN, PropertyConditionPhase.MOVE_OUT] as const;
